<template>
  <v-sheet class="elevation-2">
    <div
      class="new-messages-button"
      v-if="showScrollToNewMessagesButton"
    >
      <v-badge
        color="secondary"
        left
        overlap
      >
        <template
          v-slot:badge
          v-if="newMessagesCount"
        >
          {{ newMessagesCount }}
        </template>
        <v-btn
          fab
          small
          color="primary"
          @click="$bus.$emit('scroll-chat-' + chatComponentId)"
        >
          <v-icon>keyboard_arrow_down</v-icon>
        </v-btn>
      </v-badge>
    </div>
    <input-attachments :imagesBucket="this.imagesBucket" :filesBucket="this.filesBucket" />

    <v-container
      class="ma-0 pa-2 grey lighten-4"
      fluid
      fill-height
    >
      <v-layout row>
        <v-flex>

          <v-sheet class="editor">
            <editor-content
              class="elevation-2"
              :editor="editor"
              v-model="message"
            />
          </v-sheet>

          <v-item-group dir="ltr">
            
            <v-btn
              icon
              v-shortkey="{win: ['cntl', 'enter'], mac: ['meta', 'enter']}"
              @shortkey="sendMessage"
              @click="sendMessage"
              :loading="sending"
              :disabled="!canSend()"
            >
              <v-icon class="flip-horizontal">send</v-icon>
            </v-btn>
            <my-dropzone
              :bucket="filesBucket"
              :key="filesBucket"
              icon="attachment"
              :is-files="true"
              title="הוספת קבצים"
              :upload-folder="'files'"
            />
            <my-dropzone
              :bucket="imagesBucket"
              :key="imagesBucket"
              icon="image"
              title="הוספת תמונות"
              :upload-folder="'originals'"
            />
            <!-- <v-btn
              icon
              
            >
              <v-icon class="">attachment</v-icon>
            </v-btn> -->
            <!-- <v-menu offset-y>
              <v-btn
                slot="activator"
                icon
              >
                <v-icon>attachment</v-icon>
              </v-btn>
              <v-list>
                <v-list-tile
                  v-for="(item, index) in attachmentMenu"
                  :key="index"
                  @click=""
                  :disabled="item.disabled"
                >
                  <v-list-tile-title>
                    <v-icon>{{ item.icon }}</v-icon>{{ item.title }}
                  </v-list-tile-title>
                </v-list-tile>
              </v-list>
            </v-menu> -->
            <!-- <v-btn icon>
              <v-icon>more_vert</v-icon>
            </v-btn> -->
          </v-item-group>
        </v-flex>
      </v-layout>
    </v-container>
    <div
      class="suggestion-list"
      v-show="showSuggestions"
      ref="suggestions"
    >
      <template v-if="hasResults">
        <div
          v-for="(user, index) in filteredUsers"
          :key="user.id"
          class="suggestion-list__item"
          :class="{ 'is-selected': navigatedUserIndex === index }"
          @click="selectUser(user)"
        >
          {{ user.name }}
        </div>
      </template>
      <div
        v-else
        class="suggestion-list__item is-empty"
      >
        אין הצעות
      </div>
    </div>
  </v-sheet>
</template>

<script>
import Fuse from "fuse.js";
import tippy from "tippy.js";
import { Editor, EditorContent } from "tiptap";
import { Placeholder, Mention } from "tiptap-extensions";
import Hashtag from "@/utils/tiptap/Hashtag";
import InputAttachments from "./InputAttachments.vue";
import { getApi } from "@/api";
import generateId from "@/idGenerator";
import MyDropzone from "@/components/uploader/MyDropzone.vue";

export default {
  data() {
    return {
      editor: null,
      message: null,
      messageJson: null,
      sending: false,
      filesBucket: generateId(),
      imagesBucket: generateId(),
      // attachmentMenu: [
      //   {
      //     title: "מיקום",
      //     icon: "location_on",
      //     disabled: true
      //   },
      //   {
      //     title: "קובץ",
      //     icon: "attachment"
      //   },
      //   {
      //     title: "תמונה",
      //     icon: "image"
      //   }
      // ],
      query: null,
      suggestionRange: null,
      filteredUsers: [],
      navigatedUserIndex: 0,
      insertMention: () => {}
    };
  },

  computed: {
    users() {
      return Object.values(this.$store.state.entities.users)
        .filter(item => {
          return item.isActive;
        })
        .map(item => {
          return {
            id: item.slackId || item.name,
            name: item.name
          };
        });
    },
    hasResults() {
      return this.filteredUsers.length;
    },
    showSuggestions() {
      return this.query || this.hasResults;
    },
    user() {
      return this.$store.getters["user/user"];
    },
    showScrollToNewMessagesButton() {
      return this.$store.getters["chats/showScrollToNewMessagesButton"];
    },
    newMessagesCount() {
      return this.$store.getters["chats/newMessagesCount"];
    },
    hashtags() {
      return Object.values(this.$store.state.entities.hashtags) || [];
    },
    images() {
      return this.$store.getters["uploader/files"](this.imagesBucket);
    },
    files() {
      return this.$store.getters["uploader/files"](this.filesBucket);
    },
    blocks() {
      let blocks = [];
      if (this.images && Array.isArray(this.images)) {
        for (let item of this.images.filter(item => { return item.status === 'uploaded' })) {
          blocks.push({
            type: 'image',
            data: {
              // url: item.server_filename,
              filename: item.server_filename,
              originalFilename: item.filename
            }
          })
        }
      }

      if (this.files && Array.isArray(this.files)) {
        for (let item of this.files.filter(item => { return item.status === 'uploaded' })) {
          blocks.push({
            type: 'file',
            data: {
              url: 'http://cdn1.rescue-1.co.il/files/' + item.server_filename,
              filename: item.server_filename,
              originalFilename: item.filename,
              filetype: item.filetype
            }
          })
        }
      }

      return blocks;
    }
  },

  methods: {
    canSend() {
      // add attachments checks
      if (this.images) {
        for (let item of this.images) {
          if (item.upload.progress < 100 || item.status === 'upload-error') {
            return false;
          }
        }
        return true;
      }
      if(this.files) {
        for (let item of this.files) {
          if (item.upload.progress < 100 || item.status === 'upload-error') {
            return false;
          }
        }
        return true;
      }
      return !!this.message;
    },
    removeHashtags(str) {
      let tags = [];
      let helperStr = str;
      while (helperStr) {
        str = helperStr;
        helperStr = this.removeHashtagsHelper(str);
      }
      return str;
    },
    removeHashtagsHelper(str) {
      const HASHTAG_HTML_START = '<span class="hashtag"';
      const HASHTAG_HTML_END = "</span>";
      let x = str.indexOf(HASHTAG_HTML_START);
      let y = str.substring(x).indexOf(HASHTAG_HTML_END) + x;
      if (x === -1) {
        return null;
      } else {
        return (
          str.substring(0, x).trim() +
          " " +
          str.substring(y + HASHTAG_HTML_END.length).trim()
        );
      }
    },
    parseHashtags(json, tags) {
      if (!json) { return };
      if (json.type === "hashtag") {
        tags.push(json.attrs.id);
      } else {
        if (json.content && Array.isArray(json.content)) {
          for (let subJson of json.content) {
            this.parseHashtags(subJson, tags);
          }
        }
      }
    },
    sendMessage() {
      if (!this.canSend()) return;
      this.sending = true;
      this.editor.setOptions({ editable: false });
      let text = this.removeHashtags(this.message);
      let tags = [];
      this.parseHashtags(this.messageJson, tags);
      const defaultTag = "יומן_אירועים";
      const mergedTags = Array.from(new Set([defaultTag, ...(tags || [])]));
      let message = {
        _id: generateId(),
        user: this.user._id,
        text,
        rawProseMirror: this.messageJson,
        tags: mergedTags,
        blocks: this.blocks
      };

      // Check if we're in כולם mode (multiple events)
      const eventIdsToShow = this.$store.getters["events/eventIdsToShow"];
      const isAllEventsMode = eventIdsToShow && eventIdsToShow.length > 1;

      if (isAllEventsMode) {
        // Send message to all events in the ARAN
        console.log('ChatFooter sendMessage - sending to all events:', eventIdsToShow);
        
        // Get all chat IDs for the events
        const allChats = Object.values(this.$store.state.entities.chats);
        const chatIds = allChats
          .filter(chat => eventIdsToShow.includes(chat.event))
          .map(chat => chat._id);

        console.log('ChatFooter sendMessage - chat IDs to send to:', chatIds);

        // Send message to all chats
        const sendPromises = chatIds.map(chatId => {
          return getApi().then(api => {
            return api.post(
              `/chats/${chatId}/send-message?failGracefully=true`,
              message
            );
          });
        });

        Promise.all(sendPromises)
          .then((responses) => {
            console.log("Sent to all events");
            const patchPromises = (responses || []).map((res) => {
              const created = res && res.data;
              const messageId = (created && created._id) || message._id;
              return getApi()
                .then(api => api.patch(`/chat-messages/${messageId}`, { _id: messageId, tags: mergedTags }))
                .then((patchRes) => {
                  if (patchRes && patchRes.data) {
                    this.$store.commit("UPDATE_ENTITIES", {
                      entities: { chatMessages: { [messageId]: { _id: messageId, tags: patchRes.data.tags || mergedTags } } },
                      list: [],
                      listEntitiesType: "chatMessages",
                      replace: false
                    });
                  }
                })
                .catch(() => {});
            });
            return Promise.all(patchPromises);
          })
          .then(() => {
            this.message = null;
            this.messageJson = null;
            this.$store.commit('uploader/CLEAR_BUCKET', { bucket: this.imagesBucket });
            this.$store.commit('uploader/CLEAR_BUCKET', { bucket: this.filesBucket });
            this.editor.clearContent();
          })
          .catch(err => {
            console.log(err);
          })
          .finally(() => {
            this.sending = false;
            this.editor.setOptions({ editable: true });
          });
      } else {
        // Send message to single event (normal mode)
        getApi()
          .then(api => {
            return api.post(
              `/chats/${this.chatId}/send-message?failGracefully=true`,
              message
            );
          })
          .then((res) => {
            console.log("Sent");
            const created = res && res.data;
            const messageId = (created && created._id) || message._id;
            return getApi()
              .then(api => api.patch(`/chat-messages/${messageId}`, { _id: messageId, tags: mergedTags }))
              .then((patchRes) => {
                if (patchRes && patchRes.data) {
                  this.$store.commit("UPDATE_ENTITIES", {
                    entities: { chatMessages: { [messageId]: { _id: messageId, tags: patchRes.data.tags || mergedTags } } },
                    list: [],
                    listEntitiesType: "chatMessages",
                    replace: false
                  });
                }
              })
              .catch(() => {});
          })
          .then(() => {
            this.message = null;
            this.messageJson = null;
            this.$store.commit('uploader/CLEAR_BUCKET', { bucket: this.imagesBucket });
            this.$store.commit('uploader/CLEAR_BUCKET', { bucket: this.filesBucket });
            this.editor.clearContent();
          })
          .catch(err => {
            console.log(err);
          })
          .finally(() => {
            this.sending = false;
            this.editor.setOptions({ editable: true });
          });
      }
    },
    // addHashtag(data) {
    //   if (this.message[this.message.length - 1] !== " ") {
    //     this.message += " ";
    //   }
    //   this.message += data;
    // },

    // navigate to the previous item
    // if it's the first item, navigate to the last one
    upHandler() {
      this.navigatedUserIndex =
        (this.navigatedUserIndex + this.filteredUsers.length - 1) %
        this.filteredUsers.length;
    },
    // navigate to the next item
    // if it's the last item, navigate to the first one
    downHandler() {
      this.navigatedUserIndex =
        (this.navigatedUserIndex + 1) % this.filteredUsers.length;
    },
    enterHandler() {
      const user = this.filteredUsers[this.navigatedUserIndex];
      if (user) {
        this.selectUser(user);
      }
    },
    // we have to replace our suggestion text with a mention
    // so it's important to pass also the position of your suggestion text
    selectUser(user) {
      this.insertMention({
        range: this.suggestionRange,
        attrs: {
          id: user.id,
          label: user.name
        }
      });
      this.editor.focus();
    },
    // renders a popup with suggestions
    // tiptap provides a virtualNode object for using popper.js (or tippy.js) for popups
    renderPopup(node) {
      if (this.popup) {
        return;
      }
      this.popup = tippy(node, {
        content: this.$refs.suggestions,
        trigger: "mouseenter",
        interactive: true,
        theme: "dark",
        placement: "top-start",
        inertia: true,
        duration: [400, 200],
        showOnInit: true,
        arrow: true,
        arrowType: "round"
      });
    },
    destroyPopup() {
      if (this.popup) {
        this.popup.destroy(true);
        this.popup = null;
      }
    }
  },

  mounted() {
    this.editor = new Editor({
      content: "",
      onUpdate: ({ getHTML, getJSON }) => {
        let html = getHTML();
        if (html === "<p></p>") html = null;
        this.message = html;
        this.messageJson = getJSON();
      },
      extensions: [
        new Placeholder({
          emptyClass: "is-empty",
          emptyNodeText: "הודעה…",
          showOnlyWhenEditable: true
        }),
        new Hashtag({
          // a list of all suggested items
          items: () =>
            this.hashtags.map(item => {
              return {
                id: item.title,
                name: item.title
              };
            }),
          // is called when a suggestion starts
          onEnter: ({ items, query, range, command, virtualNode }) => {
            console.log("onEnter", {
              items,
              query,
              range,
              command,
              virtualNode
            });
            this.query = query;
            this.filteredUsers = items;
            this.suggestionRange = range;
            this.renderPopup(virtualNode);
            // we save the command for inserting a selected mention
            // this allows us to call it inside of our custom popup
            // via keyboard navigation and on click
            this.insertMention = command;
          },
          // is called when a suggestion has changed
          onChange: ({ items, query, range, virtualNode }) => {
            console.log("onChange", { items, query, range, virtualNode });
            this.query = query;
            this.filteredUsers = items;
            this.suggestionRange = range;
            this.navigatedUserIndex = 0;
            this.popup.set({});
            this.renderPopup(virtualNode);
          },
          // is called when a suggestion is cancelled
          onExit: () => {
            console.log("onExit");
            // reset all saved values
            this.query = null;
            this.filteredUsers = [];
            this.suggestionRange = null;
            this.navigatedUserIndex = 0;
            this.destroyPopup(true);
          },
          // is called on every keyDown event while a suggestion is active
          onKeyDown: ({ event }) => {
            // pressing up arrow
            if (event.keyCode === 38) {
              this.upHandler();
              return true;
            }
            // pressing down arrow
            if (event.keyCode === 40) {
              this.downHandler();
              return true;
            }
            // pressing enter
            if (event.keyCode === 13) {
              this.enterHandler();
              return true;
            }
            return false;
          },
          // is called when a suggestion has changed
          // this function is optional because there is basic filtering built-in
          // you can overwrite it if you prefer your own filtering
          // in this example we use fuse.js with support for fuzzy search
          onFilter: (items, query) => {
            console.log("onFilter", items, query);
            if (!query) {
              return items;
            }
            const fuse = new Fuse(items, {
              threshold: 0.2,
              keys: ["name"]
            });
            return fuse.search(query);
          }
        }),
        new Mention({
          // a list of all suggested items
          items: () => this.users,
          // is called when a suggestion starts
          onEnter: ({ items, query, range, command, virtualNode }) => {
            console.log("onEnter", {
              items,
              query,
              range,
              command,
              virtualNode
            });
            this.query = query;
            this.filteredUsers = items;
            this.suggestionRange = range;
            this.renderPopup(virtualNode);
            // we save the command for inserting a selected mention
            // this allows us to call it inside of our custom popup
            // via keyboard navigation and on click
            this.insertMention = command;
          },
          // is called when a suggestion has changed
          onChange: ({ items, query, range, virtualNode }) => {
            console.log("onChange", { items, query, range, virtualNode });
            this.query = query;
            this.filteredUsers = items;
            this.suggestionRange = range;
            this.navigatedUserIndex = 0;
            this.popup.set({});
            this.renderPopup(virtualNode);
          },
          // is called when a suggestion is cancelled
          onExit: () => {
            console.log("onExit");
            // reset all saved values
            this.query = null;
            this.filteredUsers = [];
            this.suggestionRange = null;
            this.navigatedUserIndex = 0;
            this.destroyPopup(true);
          },
          // is called on every keyDown event while a suggestion is active
          onKeyDown: ({ event }) => {
            // pressing up arrow
            if (event.keyCode === 38) {
              this.upHandler();
              return true;
            }
            // pressing down arrow
            if (event.keyCode === 40) {
              this.downHandler();
              return true;
            }
            // pressing enter
            if (event.keyCode === 13) {
              this.enterHandler();
              return true;
            }
            return false;
          },
          // is called when a suggestion has changed
          // this function is optional because there is basic filtering built-in
          // you can overwrite it if you prefer your own filtering
          // in this example we use fuse.js with support for fuzzy search
          onFilter: (items, query) => {
            console.log("onFilter", items, query);
            if (!query) {
              return items;
            }
            const fuse = new Fuse(items, {
              threshold: 0.2,
              keys: ["name"]
            });
            return fuse.search(query);
          }
        })
      ]
    });
  },

  beforeDestroy() {
    this.editor.destroy();
  },

  props: ["chatId", "chatComponentId"],

  components: {
    EditorContent,
    InputAttachments,
    MyDropzone
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "~tippy.js/index.css";

.container {
  margin: 0;
  padding: 0 0 0 0;
}
</style>

<style lang="scss">
.ProseMirror {
  max-height: 150px;
  padding: 12px;
  overflow: auto;
  font-size: 16px;
}

.ProseMirror:focus {
  outline: unset !important;
}

.prosemirror-focused {
  outline: unset !important;
}

.editor p.is-empty:first-child::before {
  content: attr(data-empty-text);
  float: right;
  color: #aaa;
  pointer-events: none;
  height: 0;
  font-style: italic;
}

.editor p {
  margin-bottom: 0;
}

.mention,
.hashtag {
  background: rgba(#000, 0.1);
  color: rgba(#000, 0.6);
  font-size: 16px;
  font-weight: bold;
  border-radius: 5px;
  padding: 0.2rem 0.5rem;
  white-space: nowrap;
}

.hashtag {
  background: rgba(#ff0000, 0.1);
}

.mention-suggestion {
  color: rgba(#000, 0.6);
}
.suggestion-list {
  padding: 0.2rem;
  border: 2px solid rgba(#000, 0.1);
  font-size: 0.8rem;
  font-weight: bold;
  &__no-results {
    padding: 0.2rem 0.5rem;
  }
  &__item {
    border-radius: 5px;
    padding: 0.2rem 0.5rem;
    margin-bottom: 0.2rem;
    direction: rtl;
    cursor: pointer;
    &:last-child {
      margin-bottom: 0;
    }
    &.is-selected,
    &:hover {
      background-color: rgba(#fff, 0.2);
    }
    &.is-empty {
      opacity: 0.5;
    }
  }
}
.tippy-tooltip.dark-theme {
  background-color: #000;
  padding: 0;
  font-size: 1rem;
  text-align: inherit;
  color: #fff;
  border-radius: 5px;
  .tippy-backdrop {
    display: none;
  }
  .tippy-roundarrow {
    fill: #000;
  }
  .tippy-popper[x-placement^="top"] & .tippy-arrow {
    border-top-color: #000;
  }
  .tippy-popper[x-placement^="bottom"] & .tippy-arrow {
    border-bottom-color: #000;
  }
  .tippy-popper[x-placement^="left"] & .tippy-arrow {
    border-left-color: #000;
  }
  .tippy-popper[x-placement^="right"] & .tippy-arrow {
    border-right-color: #000;
  }
}

.buttons-container {
  width: 100px;
}

.new-messages-button {
  position: absolute;
  top: -55px;
  left: 5px;
}
</style>


// WEBPACK FOOTER //
// src/components/chat/ChatFooter.vue